import { render } from "./ConfigurationTab.vue?vue&type=template&id=362af40e&scoped=true"
import script from "./ConfigurationTab.vue?vue&type=script&lang=js"
export * from "./ConfigurationTab.vue?vue&type=script&lang=js"

import "./ConfigurationTab.vue?vue&type=style&index=0&id=362af40e&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362af40e"]])

export default __exports__